import clsx from 'clsx';
import { type FCC } from 'types';
import styles from './IconButton.module.scss';

interface IconButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  icon: JSX.Element;
  className?: string;
}

const IconButton: FCC<IconButtonProps> = (props): JSX.Element => {
  const { icon, className, ...buttonProps } = props;

  return (
    <button type="button" className={clsx(styles.iconButton, className)} {...buttonProps}>
      {icon}
    </button>
  );
};

export default IconButton;
